import { useEffect, useState } from 'react';

export const useCssReady = (
  active = true,
  fallbackMs = 4000,
): boolean => {
  const [cssReady, setCssReady] = useState(false);

  useEffect(() => {
    if (!active) {
      setCssReady(false);
      return undefined;
    }

    const links = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ) as HTMLLinkElement[];

    const pending = links.filter((link) => !link.sheet);

    if (pending.length === 0) {
      setCssReady(true);
      return undefined;
    }

    let remaining = pending.length;

    const markLoaded = () => {
      remaining -= 1;

      if (remaining <= 0) {
        setCssReady(true);
      }
    };

    pending.forEach((link) => {
      link.addEventListener('load', markLoaded, { once: true });
      link.addEventListener('error', markLoaded, { once: true });
    });

    const fallback = setTimeout(() => setCssReady(true), fallbackMs);

    return () => {
      clearTimeout(fallback);

      pending.forEach((link) => {
        link.removeEventListener('load', markLoaded);
        link.removeEventListener('error', markLoaded);
      });
    };
  }, [active, fallbackMs]);

  return cssReady;
};
